export default __webpack_public_path__ + "static/media/ArrowLeftWhite.45671f40.svg";